import NeedRealAccountForCashierModal from './need-real-account-for-cashier-modal';
import './need-real-account-for-cashier-modal.scss';

export default NeedRealAccountForCashierModal;
